var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139 607L139 635",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.5,
    cy: 602.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.987 602.19C134.987 598.283 138.288 595.117 142.358 595.117C142.943 595.117 143.511 595.184 144.056 595.308C142.742 594.48 141.187 594 139.519 594C134.814 594 131 597.806 131 602.5C131 607.194 134.814 611 139.519 611C141.814 611 143.895 610.093 145.427 608.62C144.492 609.032 143.454 609.263 142.358 609.263C138.288 609.263 134.987 606.096 134.987 602.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.402 601.6L148.37 599.146L146.536 600.719L144.304 600.056L145.112 602.337L143.765 604.381L146.1 604.218L147.499 606.144L148.133 603.763L150.345 602.909L148.402 601.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch5);
export default __webpack_public_path__ + "static/media/church_5.c2963df0802c789b50c8989dc41a6f91.svg";
export { ForwardRef as ReactComponent };